<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="9">
            <h3>Validar Usuários</h3>
          </b-col>
          <b-col md="3">
            <p><b>Nome:</b> {{ usuarioLogado.nome }}</p>
            <p><b>Perfil:</b> {{ usuarioLogado.perfil }}</p>
            <p><b>Estado:</b> {{ usuarioLogado.estado }}</p>
            <p><b>Município:</b> {{ usuarioLogado.municipio }}</p>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="12">
            <b-form-group label="Nome, E-mail e CPF (sem pontuação):">
              <b-form-input
                type="text"
                id="name"
                v-model="filtros.filter"
                placeholder="Nome, E-mail"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3">
            <b-form-group label="Tipo de Usuário:">
              <b-form-select
                v-model="filtros.tipo"
                placeholder="Tipo de Usuário"
                class="mb-3"
              >
                <option selected :value="null">Selecione</option>
                <option
                  v-for="item in listacombo"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.nome }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="3">
            <b-form-group label="Situação:">
              <b-form-select
                v-model="filtros.situacao"
                placeholder="Situação"
                class="mb-3"
              >
                <option selected :value="null">Selecione</option>
                <option value="AT">Ativo</option>
                <option value="RJ">Rejeitado</option>
                <option value="PP">Pendente Ativação</option>
                <option value="PA">Pendente Ativação</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <b-form-select style="width: 100px; float: right" class="mb-3" v-model="totalPorPagina" :options="totalSelectOp"></b-form-select>
              <table
                aria-rowcount="4"
                id="my-table"
                aria-busy="false"
                aria-colcount="7"
                class="
                  table
                  table-responsive-sm
                  table-bordered
                  table-striped
                  table-sm
                "
              >
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">E-mail</th>
                    <th scope="col">Tipo Usuário</th>
                    <th scope="col">UF</th>
                    <th scope="col">Município</th>
                    <th scope="col">Situação</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="usuarios.data !== undefined">
                  <tr v-for="usuario in usuarios.data" :key="usuario.id">
                    <td>{{ usuario.nome }}</td>
                    <td>{{ usuario.email }}</td>
                    <td>{{ usuario.perfil }}</td>
                    <td>{{ usuario.sigla }}</td>
                    <td>{{ usuario.cidade }}</td>
                    <td>
                      <span
                        v-if="usuario.situacao === 'AT'"
                        class="badge badge-success"
                        >Ativo</span
                      >
                      <span
                        v-if="usuario.situacao === 'SU'"
                        class="badge badge-dark"
                        >Inativo</span
                      >
                      <span
                        v-if="usuario.situacao === 'PP'"
                        class="badge badge-warning"
                        >Pendente de Aprovação</span
                      >
                      <span
                        v-if="usuario.situacao === 'PA'"
                        class="badge badge-warning"
                        >Pendente de Ativação</span
                      >
                      <span
                        v-if="usuario.situacao === 'RJ'"
                        class="badge badge-danger"
                        >Rejeitado</span
                      >
                    </td>
                    <td style="width: 15%">
                      <a
                        v-if="can('user.update')"
                        class="btn btn-sm btn-secondary action"
                        title="Editar"
                        @click="editarUsuario(usuario.id)"
                      >
                        <i class="fa fa-pencil-square-o"></i>
                      </a>
                      <a
                        v-if="can('user.show')"
                        class="btn btn-sm btn-secondary action"
                        title="Visualizar"
                        @click="visualizarUsuario(usuario.id)"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                      <a
                        v-if="
                          can('user.destroy') &&
                          usuario.id !== usuarioCorrente &&
                          usuario.perfil_id === 1
                        "
                        class="btn btn-sm btn-secondary action"
                        title="Excluir"
                        @click="excluirUsuario(usuario.id, 'excluir')"
                      >
                        <i class="fa fa-times"></i>
                      </a>
                      <a
                        v-if="
                          usuario.id !== usuarioCorrente &&
                          (usuario.perfil_id === 5 || usuario.perfil_id === 4)
                        "
                        class="btn btn-sm btn-secondary action"
                        title="Gerar Pdf"
                        @click="ModalPdf(usuario.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i>
                      </a>
                      <span
                        v-if="
                          can('user.ativar') &&
                          (usuario.perfil_id === 1 ||
                            usuario.perfil_id === 8) &&
                          (usuario.situacao === 'PA' ||
                            usuario.situacao === 'SU')
                        "
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Ativar"
                          @click="modalAtivarUsuario(usuario.id)"
                        >
                          <i class="fa fa-toggle-off"></i>
                        </a>
                      </span>
                      <span
                        v-if="
                          usuario.perfil === 'Voluntario' &&
                          usuario.situacao === 'AT' &&
                          usuario.voluntario_situacao !== null
                        "
                      >
                        <a
                          v-if="
                            usuario.voluntario_situacao.situacao ===
                            'CADASTRADO'
                          "
                          class="btn btn-sm btn-secondary action"
                          title="Em capacitação"
                          @click="capacitarVoluntario(usuario.id)"
                        >
                          <i class="fa fa-star"></i>
                        </a>
                        <a
                          v-if="
                            usuario.voluntario_situacao.situacao ===
                              'EM_CAPACITACAO' ||
                            usuario.voluntario_situacao.situacao === 'REPROVADO'
                          "
                          class="btn btn-sm btn-secondary action"
                          title="Aprovar"
                          @click="aprovarVoluntario(usuario.id)"
                        >
                          <i class="fa fa-thumbs-o-up"></i>
                        </a>
                        <a
                          v-if="
                            usuario.voluntario_situacao.situacao ===
                              'EM_CAPACITACAO' ||
                            usuario.voluntario_situacao.situacao === 'APROVADO'
                          "
                          class="btn btn-sm btn-secondary action"
                          title="Reprovar"
                          @click="reprovarVoluntario(usuario.id)"
                        >
                          <i class="fa fa-thumbs-o-down"></i>
                        </a>
                      </span>
                      <span
                        v-if="
                          can('user.suspender') &&
                          usuario.situacao === 'SU' &&
                          usuario.perfil_id !== 1 &&
                          usuario.perfil_id !== 8
                        "
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Ativar"
                          @click="modalAtivarUsuario(usuario.id)"
                        >
                          <i class="fa fa-toggle-off"></i>
                        </a>
                      </span>
                      <span
                        v-if="
                          can('user.suspender') &&
                          usuario.situacao === 'AT' &&
                          usuario.perfil_id !== 1 &&
                          usuario.perfil_id !== 8
                        "
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Inativar"
                          @click="modalInativarUsuario(usuario.id)"
                        >
                          <i class="fa fa-toggle-on"></i>
                        </a>
                      </span>
                      <span
                        v-if="can('user.aprovar') && usuario.situacao === 'PP'"
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Aprovar Usuário"
                          @click="aprovarUsuario(usuario.id)"
                        >
                          <i class="fa fa-thumbs-up"></i>
                        </a>
                      </span>
                      <span
                        v-if="can('user.aprovar') && usuario.situacao === 'RJ'"
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Aprovar Usuário"
                          @click="aprovarUsuario(usuario.id)"
                        >
                          <i class="fa fa-thumbs-up"></i>
                        </a>
                      </span>
                      <span
                        v-if="can('user.aprovar') && usuario.situacao === 'PP'"
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Rejeitar Usuário"
                          @click="rejeitarUsuario(usuario.id)"
                        >
                          <i class="fa fa-thumbs-down"></i>
                        </a>
                      </span>
                      <span
                      >
                        <a
                          class="btn btn-sm btn-secondary action"
                          title="Alterar Perfil"
                          @click="modalalterarperfil(usuario.id)"
                        >
                          <i class="fa fa-user-o"></i>
                        </a>
                      </span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="7">Nenhum registro de usuários...</td>
                  </tr>
                </tbody>
              </table>
              <pagination
                v-show="usuarios.data !== undefined"
                :totalPorPagina="totalPorPagina"
                :resource="resource"
              ></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      title="Alterar Perfil"
      size="md"
      :hide-footer="true"
      v-model="modalSelecao"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    autocomplete="nome"
                    v-model="usuario.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.perfil">
              <b-form-group label="Tipo de Usuário:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.perfil.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-form-group label="Selecione Novo Perfil:">
            <b-form-select  class="mb-3" v-model="trocarperfil">
              <option selected :value="null">Selecione</option>
               <option
                  v-for="item in listaperfis"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.nome }}
                </option>
            </b-form-select>
          </b-form-group>
          <b-col cols="12">
              <b-form-group label="Observação:">
                <b-input-group class="mb-3">
                  <b-form-textarea
                    class="form-control"
                    placeholder="Descreva aqui..."
                    autocomplete="Descreva aqui..."
                    row="3"
                    max-rows="3"
                    v-model="obstrocaperfil"
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>
            </b-col>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-button variant="primary" @click="alterarperfil(usuario.id)"
          ><i class="fa fa-check"></i> Salvar</b-button
        >
        <b-button variant="secondary" @click="fecharmodalalterarperfil"
          ><i class="fa fa-mail-reply-all"></i> Voltar</b-button
        >
      </b-card-footer>
    </b-modal>
    <b-modal
      :title="titulo_descricao"
      size="lg"
      :ok-title="titulo_botao"
      cancel-title="Cancelar"
      v-model="modalPreExcluir"
      @ok="modalConfirmaExclusao(tipo)"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="4">
              <b-form-group label="CPF:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-mask="'###.###.###-##'"
                    id="cpf"
                    type="text"
                    :disabled="true"
                    class="form-control"
                    placeholder="CPF"
                    autocomplete="cpf"
                    v-model="usuario.cpf"
                    autofocus
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group label="UF:">
                <b-form-select
                  v-model="usuario.estado_id"
                  placeholder="Password"
                  :options="estados"
                  class="mb-3"
                  :disabled="true"
                >
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Município:">
                <b-form-select
                  placeholder="Password"
                  :options="cidades"
                  class="mb-3"
                  v-model="usuario.cidade_id"
                  :disabled="true"
                >
                  <option selected :value="null">Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="8">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    autocomplete="nome"
                    v-model="usuario.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label="Tipo de Usuário:">
                <b-form-select
                  :disabled="true"
                  v-model="usuario.perfil_id"
                  placeholder="Tipo de Usuário"
                  class="mb-3"
                >
                  <option
                    v-for="item in listacombo"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.nome }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Ativação de Usuário"
      size="lg"
      ok-title="Aprovar"
      cancel-title="Cancelar"
      v-model="modalPreAprovar"
      @ok="modalConfirmaAprovacao"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    autocomplete="nome"
                    v-model="usuario.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="CPF:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-mask="'###.###.###-##'"
                    id="cpf"
                    type="text"
                    :disabled="true"
                    class="form-control"
                    placeholder="CPF"
                    autocomplete="cpf"
                    v-model="usuario.cpf"
                    autofocus
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.perfil">
              <b-form-group label="Tipo de Usuário:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.perfil.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.dados_institucionais">
              <b-form-group label="Instituição:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="fa fa-university" aria-hidden="true"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.dados_institucionais.nome_instituicao"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Rejeitar Usuário"
      size="lg"
      ok-title="Rejeitar"
      cancel-title="Cancelar"
      v-model="modalPreRejeitar"
      @ok="modalConfirmaRejeicao"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    autocomplete="nome"
                    v-model="usuario.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="CPF:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-mask="'###.###.###-##'"
                    id="cpf"
                    type="text"
                    :disabled="true"
                    class="form-control"
                    placeholder="CPF"
                    autocomplete="cpf"
                    v-model="usuario.cpf"
                    autofocus
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.perfil">
              <b-form-group label="Tipo de Usuário:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.perfil.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.dados_institucionais">
              <b-form-group label="Instituição:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="fa fa-university" aria-hidden="true"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.dados_institucionais.nome_instituicao"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-textarea
                id="textarea"
                :state="justificativaState"
                v-model="justificativa"
                placeholder="Justifique..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Ativar Usuário"
      size="lg"
      ok-title="Ativar"
      cancel-title="Cancelar"
      v-model="modalAtivar"
      @ok="ativarUsuario(usuario.id)"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    autocomplete="nome"
                    v-model="usuario.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="CPF:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-mask="'###.###.###-##'"
                    id="cpf"
                    type="text"
                    :disabled="true"
                    class="form-control"
                    placeholder="CPF"
                    autocomplete="cpf"
                    v-model="usuario.cpf"
                    autofocus
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.perfil">
              <b-form-group label="Tipo de Usuário:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.perfil.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.dados_institucionais">
              <b-form-group label="Instituição:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="fa fa-university" aria-hidden="true"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.dados_institucionais.nome_instituicao"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Inativar Usuário"
      size="lg"
      ok-title="Inativar"
      cancel-title="Cancelar"
      v-model="modalInativar"
      @ok="inativarUsuario(usuario.id)"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    placeholder="Nome"
                    autocomplete="nome"
                    v-model="usuario.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="CPF:">
                <b-input-group class="mb-6">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    v-mask="'###.###.###-##'"
                    id="cpf"
                    type="text"
                    :disabled="true"
                    class="form-control"
                    placeholder="CPF"
                    autocomplete="cpf"
                    v-model="usuario.cpf"
                    autofocus
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.perfil">
              <b-form-group label="Tipo de Usuário:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="icon-user"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.perfil.nome"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="usuario.dados_institucionais">
              <b-form-group label="Instituição:">
                <b-input-group class="mb-3">
                  <b-input-group-prepend>
                    <b-input-group-text
                      ><i class="fa fa-university" aria-hidden="true"></i
                    ></b-input-group-text>
                  </b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model="usuario.dados_institucionais.nome_instituicao"
                    :disabled="true"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal
      title="Ativação de Usuário"
      ok-title="Aprovar"
      cancel-title="Cancelar"
      v-model="modalPreAprovarTutor"
      @ok="modalConfirmaAprovacaoTutor"
    >
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <p>
                Deseja confirmar a ativação do usuário com a atuação que ele
                selecionou abaixo? Caso seja, altere a opção e acione o botão
                'Salvar'.
              </p>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Atuação:">
                <b-form-select
                  v-model="atuacao"
                  placeholder="Password"
                  :options="atuacoes"
                  class="mb-3"
                ></b-form-select>
                <b-form-invalid-feedback id="input1LiveFeedback5"
                  >Área de Atuação é obrigatório.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col cols="12" v-if="permitirTutorLider">
              <b-form-group>
                <b-form-checkbox
                  id="checkbox-1"
                  v-model="tutorLider"
                  name="checkbox-1"
                  :value="true"
                  :unchecked-value="false"
                  >Tutor Líder</b-form-checkbox
                >
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal
      title="Gerar PDF"
      size="lg"
      ok-title="Download"
      cancel-title="Cancelar"
      v-model="modalPdf"
      @ok="downloadPDF(usuario.nome.toUpperCase())"
    >
      <b-card-body>
        <b-form>
          <b-row ref="content" v-if="usuario.dados_pessoais && modalPdf">
            <b-col cols="12" class="text-center">
              <h5>
                FICHA DA
                {{ usuario.perfil_id === 5 ? "BENEFICIÁRIA" : "VOLUNTÁRIA" }}
                {{ usuario.nome.toUpperCase() }}
              </h5>
              <h6>
                PROJETO -
                {{ usuario.dados_pessoais.cidade.cidade.toUpperCase() }} /
                {{ usuario.dados_pessoais.cidade.estado.sigla.toUpperCase() }}
              </h6>
            </b-col>
            <b-col cols="12">
              <p>Nome: {{ usuario.nome.toUpperCase() }}</p>
              <p>CPF: {{ usuario.cpf.toUpperCase() }}</p>
              <p>
                Data de Nascimento:
                {{ usuario.dados_pessoais.data_nascimento.toUpperCase() }}
              </p>
              <p v-if="usuario.perfil_id === 5">
                Situação Social:
                {{
                  usuario.dados_pessoais.situacao_social
                    ? JSON.parse(usuario.dados_pessoais.situacao_social)[0].name
                    : ""
                }}
              </p>
              <p>
                Profissão/Ocupação:
                {{ usuario.dados_pessoais.profissao.toUpperCase() }}
              </p>
              <p v-if="estadoscivis">
                Estado Civil:
                {{
                  usuario.dados_pessoais.estado_civil
                    ? estadoscivis.find(
                        (element) =>
                          element[0] == usuario.dados_pessoais.estado_civil
                      )[1]
                    : ""
                }}
              </p>
              <p v-if="escolaridades">
                Escolaridade:
                {{
                  usuario.dados_pessoais.escolaridade
                    ? escolaridades.find(
                        (element) =>
                          element[0] == usuario.dados_pessoais.escolaridade
                      )[1]
                    : ""
                }}
              </p>
              <p v-if="usuario.perfil_id === 5">
                É mãe biológica ou adotiva:
                {{ usuario.dados_pessoais.mae ? "SIM" : "NÃO" }}
              </p>
              <p v-if="usuario.perfil_id === 5">
                Numero de filhos:
                {{
                  usuario.dados_pessoais.numero_filhos
                    ? usuario.dados_pessoais.numero_filhos
                    : "0"
                }}
              </p>
              <p v-if="usuario.perfil_id === 5">
                Quantos filhos menores de 2 anos?
                {{
                  usuario.dados_pessoais.numero_filhos_menor
                    ? usuario.dados_pessoais.numero_filhos_menor
                    : "0"
                }}
              </p>
              <p v-if="usuario.perfil_id === 5">
                É gestante?
                {{ usuario.dados_pessoais.gestante ? "SIM" : "NÃO" }}
              </p>
              <p v-if="usuario.perfil_id === 5">
                Quantas semanas de gestação?
                {{
                  usuario.dados_pessoais.semana_gestacao
                    ? semanasGestacao[usuario.dados_pessoais.semana_gestacao]
                    : ""
                }}
              </p>
              <p>
                DDD + Telefone Celular:
                {{ usuario.dados_pessoais.telefone.toUpperCase() }}
              </p>
              <p>
                Município:
                {{ usuario.dados_pessoais.cidade.cidade.toUpperCase() }}
              </p>
              <p>CEP: {{ usuario.dados_pessoais.cep.toUpperCase() }}</p>
              <p>
                Endereço: {{ usuario.dados_pessoais.endereco.toUpperCase() }}
              </p>
              <p>Número: {{ usuario.dados_pessoais.numero.toUpperCase() }}</p>
              <p>
                Complemento:
                {{ usuario.dados_pessoais.complemento.toUpperCase() }}
              </p>
              <p>Bairro: {{ usuario.dados_pessoais.bairro.toUpperCase() }}</p>
              <p v-if="usuario.perfil_id != 5">
                Quantas pessoas você pode acompanhar?
                {{ usuario.dados_pessoais.numero_pessoas_acompanhar }}
              </p>
              <p>Email: {{ usuario.email }}</p>
            </b-col>
            <b-col cols="3" offset-md="9">
              <span>Gerado dia {{ new Date().toLocaleDateString() }}</span>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
  </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'
import miniToastr from 'mini-toastr'
import JsPDF from 'jspdf'
import html2canvas from 'html2canvas'
window.html2canvas = html2canvas

miniToastr.init()

export default {
  components: {
    Pagination
  },
  props: {
    userStatus: {
      type: String,
      default: null
    },
    userType: {
      type: String,
      default: null
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'L') {
      this.$router.push('/')
      return
    }

    this.$store.dispatch('buscarTipoUsuarios')
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    this.$store.dispatch('buscarAtuacoes')
    this.$store.dispatch('buscarMunicipiosProgramas')

    if (this.userStatus !== '' || this.userType !== '') {
      this.filtros.situacao = this.userStatus
      this.filtros.tipo = this.userType
      this.searchBasedOnSituation()
    }
  },
  data () {
    return {
       modalSelecao: false,
      trocarperfil: null,
      tipoCadastro: null,
      obstrocaperfil: '',
      listaperfis: [],
      perfilCorrente: parseInt(SessionStorage.get('perfil')),
      justificativa: '',
      justificativa: '',
      justificativaState: null,
      usuarioTutorId: null,
      permitirTutorLider: false,
      tutorLider: [],
      modalAtivar: false,
      modalInativar: false,
      disabled_cidades: true,
      usuarioCorrente: parseInt(SessionStorage.get('usuario')),
      tipo: '',
      titulo_confirmacao: '',
      titulo_descricao: '',
      titulo_botao: '',
      totalPorPagina: 20,
      totalSelectOp: [
        {text: '20', value: 20},
        {text: '30', value: 30},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      resource: 'usuario',
      modalPreExcluir: false,
      modalSuspender: false,
      modalPreAprovar: false,
      modalPreAprovarTutor: false,
      modalPreRejeitar: false,
      modalPdf: false,
      situacoes: [
        { value: null, text: 'Selecione' },
        { value: '1', text: 'Aprovado' },
        { value: '0', text: 'Pendente' },
        { value: '2', text: 'Rejeitado' }
      ],
      filtros: {
        situacao: null,
        filter: '',
        tipo: null,
        uf: null,
        municipio: null,
        status: null
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: '',
        nome: ''
      },
      atuacao: 'I'
    }
  },
  mounted () {
    this.$store.dispatch('getRegistrosSearch', {
      resource: this.resource,
      limit: this.totalPorPagina,
      filtros: this.filtros
    })
  },
  computed: {
    usuarios () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    atuacoes () {
      return this.$store.state.atuacao.listaAtuacoes
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    escolaridades () {
      return Object.entries(this.$store.state.escolaridade.listaEscolaridade)
    },
    estadoscivis () {
      return Object.entries(this.$store.state.estadocivil.listaEstadoCivil)
    },
    semanasGestacao () {
      return this.$store.state.semanagestacao.listaSemanaGestacao
    }
  },
  watch: {
    'filtros.filter': function () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    'filtros.tipo': function () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    'filtros.situacao': function () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    municipiosprogramas: function () {
      this.municipiosprogramas.forEach((element) => {
        if (
          element.municipio_id ===
          this.usuario.dados_pessoais.municipio_atuacao_id
        ) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    },
    'usuario.perfil': function () {
      if (this.usuarioLogado.nome === '') {
        this.usuarioLogado.nome = this.usuario.nome
        this.usuarioLogado.perfil = this.usuario.perfil.nome
      }
    },
    atuacao: function () {
      if (this.atuacao === 'T') {
        Vue.http
          .post('api/usuario/existeTutorLider', {
            usuario_id: this.usuarioTutorId
          })
          .then((response) => {
            let retorno = response.body

            if (retorno.data.possui_lider) {
              this.permitirTutorLider = false
            } else {
              this.permitirTutorLider = true
            }

            this.modalPreAprovarTutor = true
          })
      } else {
        this.permitirTutorLider = false
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    modalalterarperfil (id) {
      this.modalSelecao = true
      this.$store.dispatch('getUsuario', id)

      switch (this.perfilCorrente) {
        case 1 : this.listaperfis = [{id: 2, nome: 'Gestor Político'}, {id: 3, nome: 'Tutor Local'}, {id: 4, nome: 'Voluntária'}, {id: 5, nome: 'Beneficiária'}]; break
        case 2 : this.listaperfis = [{id: 3, nome: 'Tutor Local'}, {id: 4, nome: 'Voluntária'}, {id: 5, nome: 'Beneficiária'}]; break
        case 3 : this.listaperfis = [{id: 4, nome: 'Voluntária'}, {id: 5, nome: 'Beneficiária'}]; break
      }
    },
    fecharmodalalterarperfil () {
      this.modalSelecao = false
    },
    alterarperfil (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma a alteração de perfil?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            let data = {
              id: id,
              perfilaterado: this.trocarperfil,
              observacao: this.obstrocaperfil
            }
            Vue.http
              .post('api/usuario/alteraperfil', data)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.modalSelecao = false
                  this.trocarperfil = null
                  this.obstrocaperfil = ''
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizarUsuario (id) {
      this.$router.push('/usuario/' + id + '/visualizar')
    },
    editarUsuario (id) {
      this.$router.push('/usuario/' + id + '/editar')
    },
    excluirUsuario (id) {
      this.$bvModal
        .msgBoxConfirm('Deseja realmente excluir esse usuário?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get('api/usuario/excluir/' + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
              .catch((erro) => {
                if (!erro.body.success) {
                  miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
                  miniToastr.error(erro.body.msg, 'Alerta!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    modalAtivarUsuario (id) {
      this.modalAtivar = true
      this.$store.dispatch('getUsuario', id)
    },
    modalInativarUsuario (id) {
      this.modalInativar = true
      this.$store.dispatch('getUsuario', id)
    },
    ModalPdf (id) {
      this.modalPdf = true
      this.$store.dispatch('buscarEscolaridades')
      this.$store.dispatch('buscarEstadosCivil')
      this.$store.dispatch('buscarSituacoesSociais')
      this.$store.dispatch('buscarSemanaGestacao')
      this.$store.dispatch('getUsuario', id)
    },
    downloadPDF (nome) {
      const doc = new JsPDF()
      const contentHtml = this.$refs.content

      html2canvas(contentHtml).then(function (canvas) {
        var imgData = canvas.toDataURL('image/png')
        doc.addImage(imgData, 'PNG', 10, 10)
        doc.save(nome + '.pdf')
      })
    },
    inativarUsuario (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma a inativação do registro selecionado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http.get('api/usuario/suspender/' + id).then((response) => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {
                  resource: this.resource,
                  limit: this.totalPorPagina,
                  filtros: this.filtros
                })
              }
            })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    ativarUsuario (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma a ativação do registro selecionado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http.get('api/usuario/ativar/' + id).then((response) => {
              if (response.body.success) {
                miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                this.$store.dispatch('getRegistrosSearch', {
                  resource: this.resource,
                  limit: this.totalPorPagina,
                  filtros: this.filtros
                })
              }
            })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    navigate (route) {
      this.$router.push(route)
    },
    modalConfirmaAprovacao () {
      this.$bvModal
        .msgBoxConfirm('Confirma a ativação do registro selecionado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get('api/usuario/aprovar/' + this.usuario.id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    modalConfirmaAprovacaoTutor () {
      this.$bvModal
        .msgBoxConfirm('Confirma a ativação do registro selecionado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            let tutorLider = 0

            /** Quando o tipo de atuação for igual a Tutor e o município permitir o cadastro de um líder, então ele acessa essa lógica. */
            if (this.permitirTutorLider) {
              if (this.tutorLider.length) {
                tutorLider = this.tutorLider.length
              }
            }

            Vue.http
              .post('api/usuario/aprovarTutorInstrutor', {
                usuario_id: this.usuarioTutorId,
                tutorLider: tutorLider
              })
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    modalConfirmaRejeicao (bvModalEvt) {
      if (!this.justificativa) {
        this.justificativaState = false
        bvModalEvt.preventDefault()
        return false
      }

      this.$bvModal
        .msgBoxConfirm('Confirma a rejeição do registro selecionado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .put('api/usuario/rejeitar/' + this.usuario.id, {
                justificativa: this.justificativa
              })
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.justificativa = ''
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    aprovarUsuario (id, perfilId) {
      if (perfilId === 3) {
        this.usuarioTutorId = id

        if (this.atuacao === 'T') {
          Vue.http
            .post('api/usuario/existeTutorLider', { usuario_id: id })
            .then((response) => {
              let retorno = response.body

              if (retorno.data.possui_lider) {
                this.permitirTutorLider = false
              } else {
                this.permitirTutorLider = true
              }
            })
        }

        this.modalPreAprovarTutor = true
      } else {
        this.modalPreAprovar = true
        this.$store.dispatch('getUsuario', id)
      }
    },
    rejeitarUsuario (id) {
      this.$store.dispatch('getUsuario', id)
      this.modalPreRejeitar = true
    },
    aprovarVoluntario (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma que o registro selecionado foi aprovado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get('api/usuario/aprovarVoluntario/' + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    reprovarVoluntario (id) {
      this.$bvModal
        .msgBoxConfirm('Confirma que o registro selecionado foi reprovado?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            Vue.http
              .get('api/usuario/reprovarVoluntario/' + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    capacitarVoluntario (id) {
      this.$bvModal
        .msgBoxConfirm(
          'Confirma que o registro selecionado se encontra em capacitação?',
          {
            okTitle: 'Confirmar',
            cancelTitle: 'Cancelar'
          }
        )
        .then((valor) => {
          if (valor) {
            Vue.http
              .get('api/usuario/capacitarVoluntario/' + id)
              .then((response) => {
                if (response.body.success) {
                  miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
                  miniToastr.success(response.body.msg, 'Sucesso!', 7000)
                  this.$store.dispatch('getRegistrosSearch', {
                    resource: this.resource,
                    limit: this.totalPorPagina,
                    filtros: this.filtros
                  })
                }
              })
          }
        })
        .catch((erro) => {
          if (!erro.body.success) {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-check' })
            miniToastr.error(erro.body.msg, 'Alerta!', 7000)
            this.$store.dispatch('getRegistrosSearch', {
              resource: this.resource,
              limit: this.totalPorPagina,
              filtros: this.filtros
            })
          }
        })
    },
    searchBasedOnSituation () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/ValidarUsuariosTutor.vue